/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';

export enum ConfigurationLocationReturnCodes {
  Success,
  DirectoryNotFound,
  DirectoryNoPermission,
}

export enum ConfigurationLocationApplyReturnCodes {
  SuccessLinkedProject,
  Success,
  Error
}

export class ConfigurationLocationPath {
  path!: string;
  isLinkedProject!: boolean;
}

export class ConfigurationLocationApplyResult {
  returnCode!: ConfigurationLocationApplyReturnCodes;
  systemsList!: SystemInfo[];
}

export class ConfigurationLocationPathPicker {
  path!: string;
  returnCode!: ConfigurationLocationReturnCodes;
}

export class ConfigurationLocationPathPickerObject {
  result!: ConfigurationLocationPathPicker;
}